module.exports = __webpack_public_path__ + "img/apps.e055d803.svg";